module.exports = __webpack_public_path__ + "img/ashmanslogo.2d1a9201.png";